'use strict'

export default (mockAxios) => {
  // パスワードポリシー取得
  mockAxios.onGet(`/passwordpolicy`).reply(200, {
    'success': true,
    'data': {
      'login_failures_permitted': 5,
      'login_lock_reset_time': 10,
      'pass_different_modify': null,
      'pass_digit_credit': 2,
      'pass_lower_credit': null,
      'pass_other_credit': null,
      'pass_prohibited_characters': '$%&',
      'pass_remember': 1,
      'pass_requisite_min': 4,
      'pass_upper_credit': null,
      'pwdlimit': 999,
      'pwdlimitadmin': 1,
      'pwdwarning': 90
    }
  })

  // パスワードポリシー更新
  mockAxios.onPut(`/passwordpolicy`).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/passwordPolicyRepositoryMock.js